//@flow
import * as React from 'react';
import { Content, Box, Columns, Column, Stack } from '@locus-taxy/neo-ui';
import LocusHeader from './LocusHeader';
import LoginBackground from './LoginBackground';
import { translate, type TFunction } from 'react-i18next';
import { ZendeskWidgetContainerFactory } from 'common/components/core/common/ZendeskWidgetContainer';
import { TicketTypeEnum } from 'common/enums/ZendeskEnum';

type Props = {
    marginTop?: 'sm' | 'lg',
    children: React.Node,
    t: TFunction
};

const LinkButton = ({ onDialogOpen, t }) => (
    <Box
        sx={{
            lineHeight: '18px',
            border: 0,
            fontSize: 14,
            outline: 'none',
            backgroundColor: 'transparent',
            fontWeight: 600,
            ...getLinkBaseStyles()
        }}
        as="button"
        onClick={onDialogOpen}
    >
        {t('support')}
    </Box>
);

const getLinkBaseStyles = () => {
    return {
        color: 'grey.200',
        textDecoration: 'underline',
        '&:hover': {
            color: 'white',
            textDecoration: 'underline'
        }
    };
};

const LoginPageWrap = (props: Props) => {
    const { t, marginTop = 'lg' } = props;
    const TranslatedLinkButton = translate('settings')(LinkButton);

    const ZendeskWidgetContainer = ZendeskWidgetContainerFactory({
        ActionComponent: TranslatedLinkButton
    });
    return (
        <Stack>
            <LoginBackground image="/img/background.svg">
                <LocusHeader />
                <Content
                    maxWidth="960px"
                    marginTop={marginTop === 'lg' ? '204px' : '50px'}
                >
                    {props.children}
                </Content>
            </LoginBackground>
            <Box backgroundColor="black" p={4}>
                <Columns align="center">
                    <Column width="3/4" />
                    <Column>
                        <ZendeskWidgetContainer
                            theme={{}} // remove this after removing theme support
                            ticketType={TicketTypeEnum.HelpAndSupport}
                            dialogHeader={t('contact')}
                        />
                    </Column>
                </Columns>
            </Box>
        </Stack>
    );
};

export default translate('settings')(LoginPageWrap);
